import Vue from 'vue'
import {
  ToastPlugin,
  ModalPlugin
} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/acl'

import toasts from '@/mixins/toast'
import areYouSure from '@/mixins/areYouSure'
import objective from './mixins/objective'

// Mixins
Vue.mixin(toasts)
Vue.mixin(areYouSure)
Vue.mixin(objective)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@core/scss/vue/libs/vue-select.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  created() {
    this.$store.dispatch('permission/getPermissionData')
  },
  render: h => h(App),
}).$mount('#app')